// Plan 4.2 — App-side guest CRUD over the /families/:familyId/guests
// surface introduced in App Backend Plan 3.6.
//
// API contract:
//   GET    /families/:familyId/guests              → EventGuest[]
//   POST   /families/:familyId/guests              → { guest, warning?, existingGuestId? }
//   PATCH  /families/:familyId/guests/:guestId     → EventGuest
//   DELETE /families/:familyId/guests/:guestId     → 204
//   POST   /families/:familyId/guests/:guestId/erase → 204
//
// All routes require auth + 404 (anti-enumeration) when the
// `eventGuests` feature flag is off on the backend.

import api from './api';
import type {
  EventGuest,
  CreateEventGuestRequest,
  UpdateEventGuestRequest,
  CreateEventGuestResponse,
} from '../types/eventGuest';

export const listGuests = (familyId: string) =>
  api.get<EventGuest[]>(`/families/${familyId}/guests`).then((r) => r.data);

export const createGuest = (familyId: string, body: CreateEventGuestRequest) =>
  api
    .post<CreateEventGuestResponse>(`/families/${familyId}/guests`, body)
    .then((r) => r.data);

export const updateGuest = (
  familyId: string,
  guestId: string,
  patch: UpdateEventGuestRequest,
) =>
  api
    .patch<EventGuest>(`/families/${familyId}/guests/${guestId}`, patch)
    .then((r) => r.data);

export const deleteGuest = (familyId: string, guestId: string) =>
  api.delete<void>(`/families/${familyId}/guests/${guestId}`).then(() => undefined);

export const eraseGuest = (familyId: string, guestId: string) =>
  api
    .post<void>(`/families/${familyId}/guests/${guestId}/erase`)
    .then(() => undefined);
